import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { SurveySubmitted, surveyUpdated } from "store/actions/surveyActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { SurveyFooterProps } from "models/propTypes/surveyPropsTypes";
//#endregion
//#region components
import { WizardFooter } from "components/common";
import { useSurveyService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import useSurveyForwardAction from "./actions/useSurveyForwardAction";
import { displayDialog } from "store/actions/utilActions";

const SurveyFooter: React.FC<SurveyFooterProps> = (props) => {
  const surveyService = useSurveyService();
  const { id, submitSurvey, reloadSurvey, isFormValid, markAsDoneHandler } = props;

  const dispatch = useDispatch();
  const { forwardActionDialog } = useSurveyForwardAction(id as string, markAsDoneHandler);

  const onSaveDraftSuccess = () => {
    reloadSurvey();
    id &&
      surveyService.getSurveyStatus(id).then((result) => {
        dispatch(surveyUpdated(result));
      });
  };

  const onSubmitSuccess = () => {
    reloadSurvey();
    id && dispatch(SurveySubmitted(id));
  };

  const onForwardClicked = async () => {
    dispatch(displayDialog(forwardActionDialog));
  };

  return (
    <WizardFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Forward),
          type: StyleEnums.DisplayType.Info,
          onClick: onForwardClicked,
        },
        {
          text: TranslationKeys.Common.SaveDraft,
          type: StyleEnums.DisplayType.Info,
          onClick: submitSurvey,
          onActionSuccess: onSaveDraftSuccess,
          successMessage: TranslationKeys.Survey.SaveSuccessMessage,
        },
        {
          text: TranslationKeys.Common.Submit2,
          type: StyleEnums.DisplayType.Success,
          onClick: submitSurvey.bind(null, true),
          onActionSuccess: onSubmitSuccess,
          isDisabled: !isFormValid,
          successMessage: TranslationKeys.Survey.SubmitSuccessMessage,
        },
      ]}
    />
  );
};

export default SurveyFooter;
